import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {PageComponent} from "../../../../core/shared/mvs-page/page.component";
import {WidgetData} from "../../../../core/shared/widget/widget-data";
import {PeriodHelper} from "../../../../core/shared/helper/period-helper";
import {FilterCriteria} from "../../../../core/shared/filter/api/filter.criteria";
import {WidgetFactory} from "../../../../core/shared/widget/service/widget.factory";
import {Sorting} from "../../../../core/shared/misc/sorting";


@Component({
    selector: 'mvs-ig-dashboard',
    templateUrl: './ig-dashboard.component.html',
    standalone: false
})
export class IgDashboardComponent extends PageComponent implements OnInit, OnChanges, OnDestroy {

    defaultLabel: string = "Integration Codes: Dashboard";

    widgetOverviewActivePassCodes: WidgetData;
    widgetOverviewActiveAccessCodes: WidgetData;
    widgetTablePassCodes: WidgetData;

    widgetTableAccessCodes: WidgetData;


    activeTabIndex: number = 0;


    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {

        const currentLocalDateTime = PeriodHelper.getCurrentLocalDateTime();

        const activeCodesFilter: FilterCriteria[] = [
            // FilterCriteria.create("e.expiryDate", FilterCriteria.cOperatorGreaterEqual, currentLocalDateTime ),
            FilterCriteria.create("e.deactivateToken", FilterCriteria.cOperatorEqual, "false" ),
        ];

        // set-up Overview Widgets
        this.widgetOverviewActivePassCodes = WidgetFactory.createWidgetListEntityBasicQl("ig.dashboard.overview.active.pass.codes.new", "Aktive Pass-Codes", "ig.IgPassToken", activeCodesFilter, [new Sorting("e.expiryDate", true)]);

        this.widgetOverviewActivePassCodes = WidgetFactory.createWidgetListEntityBasicQl("ig.dashboard.overview.active.access.codes.new", "Aktive Access-Codes", "ig.IgAccessToken", activeCodesFilter, [new Sorting("e.expiryDate", true)]);


        // set-up pass code widgets
        this.widgetTablePassCodes = WidgetFactory.createWidgetListEntityBasicQl("ig.dashboard.tab.pass.pass.codes.new", "Ausgestellte Pass Codes", "ig.IgPassToken", [], [new Sorting("e.expiryDate", true)]);



        // set-up access code widgets
        this.widgetTableAccessCodes = WidgetFactory.createWidgetListEntityBasicQl("ig.dashboard.tab.access.access.codes.new", "Ausgestellte Access Codes", "ig.IgAccessToken", [], [new Sorting("e.expiryDate", true)]);

        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
